export enum UserRoleIdEnum {
    Admin = '1',
    User = '2',
}
